import {useLocation, useNavigate} from 'react-router-dom';
import React, {useEffect} from 'react';
import './ErrorPage.css';
import Button from '../../components/Button/Button';
import {getQueryElement} from '../../utils/queryElement';
import {closeTier3ModalEvent, closeModal} from '../../utils/tier-3-modal-close/PrequalCloseEvent';
import {FormHeaderSection} from '../PrequalSinglePageApp/FormHeaderSection/FormHeaderSection';

function ErrorPage({dispatch, customerData}) {
  const navigate = useNavigate();
  useLocation();

  const closeEventHandler = () => {
    if (customerData.specialEvent.value) {
      closeModal(dispatch, customerData);
    } else {
      closeTier3ModalEvent({}, dispatch, customerData);
    }
  };

  useEffect(() => {
    getQueryElement(customerData).getElementById('prequal--web--form-section').scrollIntoView();
  }, []);

  return (
    <div id='prequal--web--form-section' className='prequal--wc--form-section'>
      <FormHeaderSection isDealerHostApplication dispatch={dispatch} customerData={customerData} navigate={navigate} />
      <div className='prequal--web--error-body-container'>
        <div className='prequal--web--error-title-fomo'>Sorry, something went wrong.</div>
        <div className='prequal--web--error-body-fomo'>
          We’re unable to process your last submission. We apologize for the inconvenience. Please try again, later.
        </div>
        <div className='prequal--web--error-body-secondary-fomo'>
          This issue has been reported to us and we are working to fix the error.
        </div>
        <div className='prequal--web--return-button-section'>
          <Button
            dataTestId='returnToHomePage'
            label='Close'
            className='prequal--web--button-fomo'
            buttonStyle='primary'
            onClick={closeEventHandler}
          >
            close
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
